import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AppProvider } from "@/context/AppContext";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { WelcomeGate } from "@/components/WelcomeGate";
import { CookieBanner } from "@/components/CookieBanner";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Mirror from "@/pages/Mirror";
import Dental from "@/pages/Dental";
import Zirconium from "@/pages/Zirconium";
import Treatments from "@/pages/Treatments";
import Journey from "@/pages/Journey";
import Clinic from "@/pages/Clinic";
import Doctors from "@/pages/Doctors";
import Results from "@/pages/Results";
import FAQPage from "@/pages/FAQPage";
import Contact from "@/pages/Contact";
import LegalPage from "@/pages/LegalPage";
import AdminLeads from "@/pages/AdminLeads";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen bg-[#05070A] text-[#F2F5F7]">
          <SiteHeader />
          <WelcomeGate />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/mirror" element={<Mirror />} />
            <Route path="/tedaviler" element={<Treatments />} />
            <Route path="/tedaviler/dis" element={<Dental />} />
            <Route path="/tedaviler/zirkonyum" element={<Zirconium />} />
            <Route path="/yolculuk" element={<Journey />} />
            <Route path="/klinik" element={<Clinic />} />
            <Route path="/hekimler" element={<Doctors />} />
            <Route path="/sonuclar" element={<Results />} />
            <Route path="/sss" element={<FAQPage />} />
            <Route path="/iletisim" element={<Contact />} />
            <Route path="/admin/leads" element={<AdminLeads />} />
            <Route path="/:slug" element={<LegalPage />} />
          </Routes>
          <SiteFooter />
          <CookieBanner />
          <Toaster position="top-center" richColors />
        </div>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
